import { useEffect, useState } from "react";
import axios from "axios";
import { Trophy } from "lucide-react";
import { Reveal } from "./Reveal";
import { CountUp } from "./CountUp";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ReferralLeaderboard = () => {
  const [leaders, setLeaders] = useState(null);

  useEffect(() => {
    let mounted = true;
    const fetchLeaders = async () => {
      try {
        const { data } = await axios.get(`${API}/waitlist/leaderboard`);
        if (mounted) setLeaders(Array.isArray(data) ? data : []);
      } catch {
        if (mounted) setLeaders([]);
      }
    };
    fetchLeaders();
    const id = setInterval(fetchLeaders, 60000);
    return () => {
      mounted = false;
      clearInterval(id);
    };
  }, []);

  if (!leaders || leaders.length === 0) return null;

  return (
    <section className="navy-breathe bg-[#0C1424] text-cream" data-testid="leaderboard-section">
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
        <div className="grid gap-14 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <p className="mb-6 text-xs font-bold uppercase tracking-[0.25em] text-gold" data-testid="leaderboard-overline">
              Referral leaderboard
            </p>
            <h2 className="font-serif text-4xl leading-tight tracking-tight md:text-5xl" data-testid="leaderboard-headline">
              The Connector <span className="italic text-gold">Board.</span>
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-cream/60 md:text-lg">
              Every friend who joins through your link counts double for your city — and earns you a spot here. The board resets when the doors open.
            </p>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-7">
            <div className="space-y-4" data-testid="leaderboard-list">
              {leaders.map((l, i) => (
                <div
                  key={l.email}
                  className={`flex items-center gap-6 rounded-3xl border p-5 md:p-6 ${
                    i === 0 ? "border-gold/50 bg-gold/5" : "border-cream/10"
                  }`}
                  data-testid={`leaderboard-row-${i}`}
                >
                  <span className="w-10 font-serif text-2xl italic text-gold/60">{String(i + 1).padStart(2, "0")}</span>
                  <div className="flex-1">
                    <p className="font-serif text-xl tracking-tight md:text-2xl" data-testid={`leaderboard-name-${i}`}>
                      {l.email}
                    </p>
                    <p className="mt-1 text-xs uppercase tracking-[0.2em] text-cream/40">{l.city}</p>
                  </div>
                  {i === 0 && <Trophy className="h-5 w-5 text-gold" data-testid="leaderboard-trophy" />}
                  <p className="text-right" data-testid={`leaderboard-count-${i}`}>
                    <span className="font-serif text-3xl text-gold"><CountUp value={l.ref_count} /></span>
                    <span className="ml-2 text-xs font-bold uppercase tracking-[0.15em] text-cream/40">
                      {l.ref_count === 1 ? "friend" : "friends"}
                    </span>
                  </p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
